import Axios from "axios";

export const API_BASE_URL =  process.env.REACT_APP_API_URL || "http://project-supervision-tool.tarurapcugeodata.or.tz";

Axios.defaults.baseURL = `${API_BASE_URL}/api/v1`;

/**
 * Axios public instance
 */
const axios = Axios.create({
  headers: {
    Accept: "application/json",
  },
});

// Set the AUTH token for any request
axios.interceptors.request.use(function (config) {
  let token;
  try {
    const persisted = JSON.parse(localStorage.getItem('pst_auth_v1') || 'null');
    token = persisted?.token || null;
  } catch {}
  if (token && !token.startsWith('Bearer ')) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (token) {
    config.headers.Authorization = token; // already complete
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

// Global response interceptor for auth handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const errorCode = error?.response?.data?.error_code;
    
    if (status === 401) {
      // Emit a custom event picked up by AuthContext (decouples axios from React concerns)
      try {
        window.dispatchEvent(new CustomEvent('pst:auth:unauthorized'));
      } catch {}
    }
    
    // Handle password-related error codes
    if (errorCode === 'PASSWORD_CHANGE_REQUIRED' || errorCode === 'PASSWORD_EXPIRED') {
      try {
        window.dispatchEvent(new CustomEvent('pst:auth:password-change-required', {
          detail: { 
            message: error.response.data.message,
            errorCode 
          }
        }));
      } catch {}
    }
    
    if (errorCode === 'INSUFFICIENT_PERMISSIONS') {
      try {
        window.dispatchEvent(new CustomEvent('pst:auth:insufficient-permissions', {
          detail: { 
            message: error.response.data.message 
          }
        }));
      } catch {}
    }
    
    return Promise.reject(error);
  }
);

export default axios;
